import { createContext } from "react";
import { Navigate } from "react-router-dom";
import { useGetMeQuery } from "src/api/services/api";
import { ProfileWithRoles } from "src/api/types";

export const ClinicianContext = createContext<ProfileWithRoles | null>(null);

interface Props {
  children: React.ReactNode;
}

const ClinicianProvider = ({ children }: Props) => {
  const { data: clinician } = useGetMeQuery();

  if (clinician == null) {
    return null;
  }

  if (clinician.roles.some((role) => role.name.includes("Patient"))) {
    return <Navigate to={`/not-found`} replace />;
  }

  return (
    <ClinicianContext.Provider value={clinician}>
      {children}
    </ClinicianContext.Provider>
  );
};

export default ClinicianProvider;
